import { AppThunk } from '..';
import {
  ADD_CHAT,
  UPDATE_CHAT,
  ADD_NEW_MESSAGE_CHAT,
  ADD_NEW_MESSAGES,
  CLEAR_CHAT,
  DELETE_CHAT_MESSAGE,
  EDIT_CHAT_MESSAGE,
} from '../actionTypes';
import { dispatchReduxError } from '../../utils/dispatchReduxError';

export type ChatMessage = {
  Content: string;
  ChannelArn?: string;
  CreatedTimestamp: string | Date;
  LastUpdatedTimestamp: string | Date;
  MessageId: string;
  Metadata: string;
  Redacted: boolean;
  Sender: {
    Arn: string;
    Name: string;
  };
  Status: {
    Value: string;
  };
  Type: string;
};

export const addChat =
  (payload: { channelArn: string; messages: ChatMessage[] }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: ADD_CHAT, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const addNewChat =
  (payload: { channelArn: string; messages: ChatMessage[] }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: ADD_NEW_MESSAGE_CHAT, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const addNewMessages =
  (payload: { channelArn: string; messages: ChatMessage[] }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: ADD_NEW_MESSAGES, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const updateChat =
  (payload: { channelArn: string; messages: Partial<ChatMessage>[] }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: UPDATE_CHAT, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const deleteChatMessage =
  (payload: { channelArn: string; messageId: string }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: DELETE_CHAT_MESSAGE, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const editChatMessage =
  (payload: { channelArn: string; messageId: string; text: string }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: EDIT_CHAT_MESSAGE, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };

export const clearChat =
  (payload: { channelArn: string }): AppThunk =>
  async dispatch => {
    try {
      dispatch({ type: CLEAR_CHAT, payload });
    } catch (error) {
      dispatchReduxError(dispatch);
    }
  };
